<template>
  <div class="orderPayment">
    <van-form label-width="110px">
      <van-field
        v-model="subData.buyer_name"
        readonly
        label-width="50px"
        @click="toBuyerList"
        name="buyer_name"
        label="客户"
        placeholder="请选择客户"
        input-align="right"
        style="font-size:0.32rem"
      >
        <template #button>
          <div style="display:flex;align-items:center">
            <span
              style="font-size:0.24rem;color:#e5a639"
              v-if="buyer_need_repayment_amount>0"
            >已欠：{{buyer_need_repayment_amount}}元</span>
            <van-icon name="arrow" />
          </div>
        </template>
      </van-field>
      <van-field
        v-model="subData.receivables"
        readonly
        name="receivables"
        label="应收(元)"
        type="number"
        placeholder="请输入应收金额"
        input-align="right"
      />
      <div class="discount">
        <div class="discount_input">
          <KeyBoardInput
            v-model="changeData.payment"
            :k_placeholder="placeholder.payment"
            :k_isValueZero="true"
            :k_default_show="true"
            :k_decimal="2"
            @input="changeCredit"
          >
            <template slot="input_left">
              <div class="input_left">实收</div>
            </template>
            <template slot="input_right">
              <div class="input_right">元</div>
            </template>
          </KeyBoardInput>
        </div>
      </div>
      <div class="discount">
        <div class="discount_input">
          <KeyBoardInput
            v-model="changeData.credit"
            :k_isValueZero="true"
            :k_decimal="2"
            @input="changeCredit"
          >
            <template slot="input_left">
              <div class="input_left">赊账</div>
            </template>
            <template slot="input_right">
              <div class="input_right">元</div>
            </template>
          </KeyBoardInput>
        </div>
      </div>
      <div class="discount">
        <div class="discount_input" style="border-color:#f1f1f1">
          <KeyBoardInput
            v-model="changeData.showDiscount"
            :k_placeholder="0"
            :k_readonly="true"
            :k_decimal="2"
          >
            <template slot="input_left">
              <span v-if="changeData.discount<=0">优惠</span>
              <span v-else>多收</span>
            </template>
            <template slot="input_right">
              <div class="input_right">元</div>
            </template>
          </KeyBoardInput>
        </div>
      </div>
      <van-field name="checkboxGroup" label="支付方式" class="check_box_payment">
        <template #input>
          <div class="pay_type_box">
            <span
              v-for="(item,index) in pay_type_list"
              :key="index"
              :class="subData.pay_type == item.value?'active':''"
              @click="changePayType(item.value)"
              v-show="on_pay_list.includes(item.value)"
            >
              <img :src="item.icon" alt />
              {{item.name}}
            </span>
          </div>
        </template>
      </van-field>
      <van-field label="打印订单" name="checkboxGroup">
        <template #input>
          <div style="text-align:right;width:100%;display:flex;align-items:center;justify-content: flex-end;">
            <van-switch v-model="subData.is_print" active-color="#31b158" size="0.48rem" active-value="1" inactive-value="0"/>
          </div>
        </template>
      </van-field>
      <van-field
        v-model="subData.remarks"
        rows="2"
        :autosize=" { maxHeight: 100, minHeight: 30 }"
        label="备注"
        type="textarea"
        label-width="50"
        maxlength="128"
        show-word-limit
      />
      <div style="margin: 16px;">
        <van-button
          style="font-size:0.36rem"
          round
          block
          type="info"
          @click="onSubmit"
          color="#31b158"
        >结 算</van-button>
      </div>
      <div style="height:1rem"></div>
    </van-form>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import { longtimestampToDate } from "@/utils/timestamp";
import { timestampToTime,longtimestampToTime } from "@/utils/timestamp.js";
import {
  order_pay,
  shopCar_delete,
  orderQueryResult,
  orderPayPos,
  orderPayType
} from "@/api/work/order/openOrder";
import { buyer_detail_base } from "@/api/work/manage/buyer";

import Cookies from "@/utils/Cookies";
export default {
  name: "orderPayment",
  components: {
    KeyBoardInput
  },
  data() {
    return {
      on_pay_list: [],
      pay_type_list: [
        {
          value: 1,
          name: "现金",
          icon: require("@/assets/img/work/open_order/order/pay_rmb.png")
        },
        {
          value: 2,
          name: "支付宝",
          icon: require("@/assets/img/work/open_order/order/pay_zfb.png")
        },
        {
          value: 3,
          name: "微信",
          icon: require("@/assets/img/work/open_order/order/pay_wx.png")
        },
        {
          value: 4,
          name: "银行卡",
          icon: require("@/assets/img/work/open_order/order/pay_yhk.png")
        },
        {
          value: 5,
          name: "POS",
          icon: require("@/assets/img/work/open_order/order/pay_pos.png")
        },
        {
          value: -1,
          name: "整单赊欠",
          icon: require("@/assets/img/work/open_order/order/pay_sq.png")
        }
      ],
      printerInfo: {},
      subData: {
        order_sn: "",
        main_sn:'', // main_sn
        buyer_id: "1",
        new_buyer_id: "1",
        buyer_name: "临时客户",
        receivables: "",
        receivables_type: 1, //1优惠，2多收
        discount: "",
        payment: "",
        pay_type: 1,
        goods: "",
        remarks: "",
        is_print:Cookies.get("is_print") || "1",
      },
      changeData: {
        receivables: "",
        payment: "",
        credit: 0,
        discount: 0,
        showDiscount: 0
      },
      buyer_need_repayment_amount: 0,
      placeholder: {
        payment: 0
      },
      total_goods_amount: 0, // 计算出来的 总的订单金额
      pos_order_sn: "",
      pos_subData: null
    };
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from,to)
    next(vm => {
      if (from.name == "public_scan" && from.meta.backData) {
        var auth_code = from.meta.backData.str;
        vm.$toast.loading({
          message: "支付中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
          overlay: true
        });
        if(auth_code){
          vm.createOrder(vm.pos_subData).then(({type,res})=>{
            var obj = vm.pos_subData
            if(type == 5){
              orderPayPos({ auth_code, order_sn: res.data.order_sn,main_sn:vm.subData.main_sn }).then(res_b => {
                if (res_b.code == 200) {
                  vm.printerInfo = Object.assign(vm.printerInfo, res_b.data);
                  if (res_b.data.pay_code == 200) {
                    ///打印
                    vm.printOrderInfo(res_b.data.order_sn,res_b.data.day_num,res_b.data.pay_date,res_b.data.trade_url,obj)

                    if (vm.changeData.credit > 0) {
                      if (vm.subData.pay_type == 5) {
                        vm.$playaudio(vm.pay_type_list[vm.subData.pay_type - 1].name +"收款，" +vm.pos_subData.payment +"元,赊帐，" +vm.changeData.credit +"元")
                      }
                    } else {
                      vm.$playaudio(vm.pay_type_list[vm.subData.pay_type - 1].name + "收款，" + vm.pos_subData.payment + "元");
                    }
                    vm.$toast.success("收银成功!");
                    setTimeout(() => {
                      vm.$router.go(-1);
                    }, 1000);
                  } else if (res_b.data.pay_code == 203) {
                    var t_count = 0;
                    var query_t = setInterval(() => {
                      t_count++;
                      if (t_count < 10) {
                        orderQueryResult({ order_sn: vm.pos_order_sn ,main_sn:vm.subData.main_sn}).then(res_p => {
                          if (res_p.code == 200) {
                            if (res_p.data.pay_code == 200) {
                              vm.printOrderInfo(res_p.data.order_sn,res_p.data.day_num,res_p.data.pay_date,res_p.data.trade_url,obj)
                              clearInterval(query_t);
                              if (vm.changeData.credit > 0) {
                                if (vm.subData.pay_type == 5) {
                                  vm.$playaudio(vm.pay_type_list[vm.subData.pay_type - 1].name +"收款，" +vm.pos_subData.payment +"元,赊帐，" +vm.changeData.credit +"元")
                                }
                              } else {
                                vm.$playaudio(vm.pay_type_list[vm.subData.pay_type - 1].name + "收款，" + vm.pos_subData.payment + "元");
                              }
                              vm.$toast.success("收银成功!");
                              setTimeout(() => {
                                vm.$router.go(-1);
                              }, 1000);
                            } else if (res_p.data.pay_code == 201) {
                              vm.$toast.fail("支付错误");
                              clearInterval(query_t);
                            } else {
                            }
                          }
                        });
                      } else {
                        clearInterval(query_t);
                      }
                    }, 3000);
                  } else {
                    vm.$toast.fail("支付错误");
                  }
                }
              });
            }
          })
        }
      }
    });
  },
  created() {
    // 返回地址
    this.$navigation.on("back", (to, from) => {
      if (to.route.name == "openOrder_orderPay") {
        if (
          from.route.name == "manage_buyer_buyerManage" &&
          from.route.meta.backData
        ) {
          var data = from.route.meta.backData;
          this.subData.new_buyer_id = data.id;
          this.subData.buyer_name = data.name;
          this.getBuyerNeed(this.subData.new_buyer_id);
        }
      }
    });
    // 判断是开单结算还是改单结算 type == 1 开单, type == 2 改单, type == 3 补单
    if (this.$route.query.type == 1) {
      var item = JSON.parse(decodeURI(this.$route.query.item));
      this.computeTotal(item);
      this.subData.main_sn = this.$route.query.main_sn;
      this.subData.buyer_name = item.buyer_name;
      this.subData.car_no = this.$route.query.car_no;
      this.subData.buyer_id = item.buyer_id;
      this.subData.new_buyer_id = item.buyer_id;
      this.subData.goods = JSON.stringify(item.order_goods);
      this.subData.receivables = this.total_goods_amount;
      this.placeholder.payment = this.total_goods_amount;
      this.changeData.receivables = this.subData.receivables;
      var remakes_list = JSON.parse(this.$route.query.remakes);
      var remake = "";
      if (remakes_list && remakes_list.length > 0) {
        for (let i = 0; i < remakes_list.length; i++) {
          const item = remakes_list[i];
          remake += item.user_name + "：" + item.desc + "\n";
        }
      }
      this.subData.remarks = remake;

      this.getBuyerNeed(this.subData.new_buyer_id);
    } else if (this.$route.query.type == 2) {
      var item = JSON.parse(decodeURI(this.$route.query.item));
      this.computeTotal(item);
      this.subData.order_sn = this.$route.query.order_sn;
      this.subData.buyer_name = item.buyer_name;
      this.subData.buyer_id = item.buyer_id;
      this.subData.goods = JSON.stringify(item.order_goods);
      this.subData.receivables = this.total_goods_amount;
      this.placeholder.payment = this.total_goods_amount;
    }
  },
  mounted() {
    orderPayType().then(res => {
      this.on_pay_list = res.data;
    });
  },
  methods: {
    // 去选择买家
    toBuyerList() {
      this.$router.push({
        path: "/manage/buyer/buyerManage",
        query: {
          use_type: 1
        }
      });
    },

    // 提交数据
    onSubmit() {
      this.subData.discount = this.changeData.discount;
      var p =
        this.changeData.payment === ""
          ? this.placeholder.payment
          : this.changeData.payment;
      this.subData.payment = p;
      if (!this.subData.pay_type) {
        this.$toast("请选择支付方式！");
        return false;
      }
      let obj = JSON.parse(JSON.stringify(this.subData));
      // obj.payment = payment;
      // 判断多收还是优惠  优惠变负数
      // if (obj.receivables_type == 1) {
      //   obj.discount = -obj.discount;
      // }
      // 如果是整单赊欠 支付方式变成现金
      if (obj.pay_type == -1) {
        obj.pay_type = 1;
      }
      delete obj.receivables_type;
      if ( obj.pay_type == 5 ) {
        this.pos_subData = JSON.parse(JSON.stringify(obj));
        this.$router.push({
          path: "/public/scan",
          query: {
            message: "",
            reg: "^[0-9]{10,50}$"
          }
        });
      } else {
        this.createOrder(obj).then(({type,res})=>{
          console.log(res)
        })
      }
    },

    // 生成订单
    createOrder(obj){
      return new Promise((resolve, reject)=>{
        order_pay(obj).then(res => {
          Cookies.set("is_print",obj.is_print)
          if (!this.subData.order_sn) {
            if (res.data.order_sn && obj.pay_type == 5) {
              this.pos_order_sn = res.data.order_sn;
              this.pos_subData = JSON.parse(JSON.stringify(obj));
              resolve({type:5,res})
            } else {
              // 打印订单
              this.printOrderInfo(res.data.order_sn,res.data.day_num,res.data.pay_date,res.data.trade_url,obj)
              if (this.changeData.credit > 0) {
                if ((this.changeData.credit - 0 + obj.discount).toFixed(2) == obj.receivables ) {
                  this.$playaudio( "整单赊欠，" + this.changeData.credit + "元")
                } else {
                  this.$playaudio(this.pay_type_list[obj.pay_type - 1].name + "收款，" + obj.payment + "元,赊帐，" + this.changeData.credit + "元");
                }
              } else {
                this.$playaudio(this.pay_type_list[obj.pay_type - 1].name + "收款，" + obj.payment + "元")
              }
              this.$toast.success("收银成功!");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
              this.$toast.success(res.message);
              resolve({type:1,res})
            }
          } else {
            this.$router.go(-2);
            this.$toast.success(res.message);
            resolve({type:1,res})
          }
        });
      })
    },

    // 打印订单信息
    printOrderInfo(order_sn,day_num,pay_date,trade_url,obj){
      try {
        let userInfo = JSON.parse(Cookies.get("userInfo"));
        let plugins_data = {
          shop_name: JSON.parse(Cookies.get("shopInfo")).shop_name || "",
          pay_type: obj.pay_type, //付款方式 1-现金 2-支付宝 3-微信 4-银行 5-POS
          pay_date,
          date: longtimestampToTime(new Date().getTime()),
          buyer_name: this.subData.buyer_name,
          car_no: this.subData.car_no,
          total_amount: obj.receivables,
          casher: userInfo.realname || '',
          address: "",
          tel: userInfo.mobile || '',
          order_sn,
          day_num,
          trade_url,
          remarks: obj.remarks, //备注
          order_amount: obj.receivables,
          payment: obj.payment,
          discount: obj.discount,
          shop_goods:JSON.parse(this.subData.goods) 
        };
        //console.log(plugins_data);
        var result= plus.bridge.execSync('sunmiPrint','printOrder',[JSON.stringify(plugins_data)])
        if(result.code == 200){
          this.$toast.success('打印成功')
        }else{
          this.$toast.fail(result.message)
        }
      } catch (error) {
        
      }
    },

    // 计算总价
    computeTotal(order_detail) {
      var goods = order_detail.order_goods;
      var amount = 0;
      for (let i = 0; i < goods.length; i++) {
        const item = goods[i];
        if (item.goods_type == 1) {
          if (item.bale == 1) {
            amount += Math.round(item.price * item.num * 100) / 100;
          } else {
            amount += Math.round(item.price * item.weight * 100) / 100;
          }
        } else if (item.goods_type == 2) {
          amount += Math.round(item.price * item.num * 100) / 100;
        }
      }
      this.total_goods_amount = amount.toFixed(2);
    },

    // 输入
    // changeDiscount() {
    //   let discount = 0;
    //   if (this.subData.discount) {
    //     discount =
    //       this.subData.receivables_type == 1
    //         ? -this.subData.discount
    //         : +this.subData.discount;
    //   } else {
    //     this.subData.discount = "";
    //   }
    //   this.placeholder.payment = Number(
    //     (this.subData.receivables - 0 + discount).toFixed(2) < 0
    //       ? 0
    //       : this.subData.receivables - 0 + discount
    //   ).toFixed(2);
    // },
    // 输入赊欠
    changeCredit() {
      var p =
        this.changeData.payment === ""
          ? this.placeholder.payment
          : this.changeData.payment;
      var s = Number(Number(p) + Number(this.changeData.credit)).toFixed(2);
      var d = Number(Number(s - this.changeData.receivables).toFixed(2));
      this.changeData.discount = d;
      this.changeData.showDiscount = Math.abs(d);
      if (
        Number(p) === 0 &&
        Number(this.changeData.credit) == Number(this.changeData.receivables) &&
        Number(this.changeData.discount) === 0
      ) {
        this.subData.pay_type = -1;
      } else {
        if (this.subData.pay_type == -1) {
          this.subData.pay_type == 1;
        }
      }
    },

    // 切换支付方式
    changePayType(value) {
      this.subData.pay_type = value;
      // 整单赊欠
      if (value == -1) {
        this.changeData.payment = 0;
        this.changeData.credit = this.changeData.receivables;
        this.changeData.discount = 0;
        this.changeData.showDiscount = 0;
      } else {
        var p =
          this.changeData.payment === ""
            ? this.placeholder.payment
            : this.changeData.payment;
        if (
          Number(p) === 0 &&
          Number(this.changeData.credit) ==
            Number(this.changeData.receivables) &&
          Number(this.changeData.discount) === 0
        ) {
          this.changeData.payment = "";
          this.changeData.credit = 0;
          this.changeData.discount = 0;
          this.changeData.showDiscount = 0;
        }
      }
    },

    // 查买家欠款额
    getBuyerNeed(id) {
      if (id != 1) {
        buyer_detail_base({ id }).then(res => {
          if (res.code == 200) {
            this.buyer_need_repayment_amount =
              res.data.need_repayment_amount || 0;
          }
        });
      } else {
        this.buyer_need_repayment_amount = 0;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.orderPayment {
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  .discount {
    position: relative;
    padding: 0.2rem 0.3rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .discount_btn {
      position: absolute;
      z-index: 3;
      // width: 2.7rem;
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 0.02rem solid #31b158;
      margin-left: 0.15rem;
      border-radius: 0.35rem;
      box-sizing: border-box;
      background-color: #eee;
      padding: 0.04rem;
      span {
        display: inline-block;
        line-height: 0.6rem;
        // border: 0.02rem solid #31b158;
        // box-shadow:  0 0 0.1rem 0.05rem #eee;
        // background-color: #eee;
        border-radius: 0.1rem;
        border-radius: 0.3rem;
        padding: 0 0.3rem;
        &:nth-child(2) {
          margin-left: -0.1rem;
        }
        &.active {
          background: #31b158;
          color: #fff;
        }
        &.zhengdan {
          width: 100%;
          color: #31b158;
          color: #fff;
          // border: none;
          // font-size: 0.28rem;
          text-align: center;
          // padding: 0;
        }
      }
    }
    .discount_input {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.32rem;
      line-height: 0.8rem;
      border: solid 0.02rem #31b158;
      border: solid 0.02rem #ccc;
      border-radius: 0.1rem;
      padding-right: 0.2rem;
      padding-left: 0.2rem;
      box-sizing: border-box;
      input {
        width: 92%;
        border-radius: 0.1rem;
        line-height: 0.8rem;
        font-size: 0.32rem;
        box-sizing: border-box;
        padding: 0 0.1rem;
        text-align: right;
      }
    }
    .credit_tip {
      position: absolute;
      z-index: 4;
      right: 0.3rem;
      bottom: -0.5rem;
      color: #f00;
      text-align: right;
      font-size: 0.32rem;
    }
  }
  .pay_type_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    span {
      width: 49%;
      box-sizing: border-box;
      line-height: 0.8rem;
      border: 0.05rem solid #f1f1f1;
      // box-shadow:  0 0 0.1rem 0.05rem #eee;
      background-color: #f1f1f1;
      border-radius: 0.1rem;
      padding: 0 0.3rem;
      text-align: center;
      // margin-right: 0.2rem;
      margin-bottom: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.3rem;
      &.active {
        // background: #31b158;
        border: 0.05rem solid #31b158;
        // color: #fff;
      }
      img {
        width: 0.5rem;
      }
    }
  }
}
</style>

<style lang="less">
.check_box_payment {
  flex-wrap: wrap;
  flex: auto;
  .van-field__value {
    margin-top: 10px;
    width: 100%;
    flex: auto;
  }
}
</style>